<template>
    <section class="Element Overview Widget" :class="mode">
        <div class="searchcolumn" v-if="mode == 'grid'">
            <div class="left">
                <div class="input-group">
                    <span class="input-group-btn">
                        <button type="button" class="btn">
                            <Icon name="search" />
                        </button>
                    </span>
                    <input type="text" class="input" placeholder="Zoeken">
                </div>
                <Dropdown>
                    hier komt inhoud
                </Dropdown>
            </div>
            <div class="right">
                <nav>
                    <button type="button" class="more" @click="togglePopup('add')">
                        <span class="title">{{ trans("App toevoegen") }}</span>
                    </button>
                </nav>
            </div>
        </div>
        <ul class="block-grid" :class="mode == 'dropdown' ? 'one-up' : 'four-up'">
            <li>
                <article class="Element Widget Item" :class="mode">
                    <div class="inner">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </div>
                </article>
            </li>
            <li>
                <article class="Element Widget Item" :class="mode">
                    <div class="inner">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </div>
                </article>
            </li>
            <li>
                <article class="Element Widget Item" :class="mode">
                    <div class="inner">
                        <span class="abbreviation" style="--bgcolor: #8fe6ad">ATS</span>
                        <span class="title">Applicant Tracking System</span>
                    </div>
                </article>
            </li>
        </ul>
    </section>
    <Popup v-if="popupVisibility['add']" :togglePopup="() => togglePopup('add')" classlist="WorkflowcardAdd">
        <div class="Heading">
            <h3 class="h3">{{ trans("Klant toevoegen") }}</h3>
        </div>
        <div class="inner">
            <form class="cs_form" ref="addForm">
                <fieldset>
                    <div class="cs_formgrid">
                        <div class="span12">
                            <div class="element TextField">
                                <label for="">Bedrijfsnaam</label>
                                <input type="text" class="input">
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="cs_formgrid">
                        <div class="span6">
                            <div class="element TextField">
                                <label for="">Voornaam</label>
                                <input type="text" class="input">
                            </div>
                        </div>
                        <div class="span6">
                            <div class="element TextField">
                                <label for="">Achternaam</label>
                                <input type="text" class="input" placeholder="Achternaam">
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <div class="cs_formgrid">
                        <div class="span12">
                            <WidgetField />
                        </div>
                    </div>
                </fieldset>
                <nav>
                    <button type="button" class="more outline" @click="togglePopup('add')">
                        <span class="title">{{ trans("Annuleren") }}</span>
                    </button>
                    <button type="submit" class="more">
                        <span class="title">{{ trans("Toevoegen") }}</span>
                    </button>
                </nav>
            </form>
        </div>
    </Popup>
</template>

<script>
import {defineComponent, inject, reactive, ref} from "vue";

import Popup from "components/popup";
import Dropdown from "components/dropdown";
import WidgetField from "components/elements/WidgetField";

import Icon from "components/icon";
import { contact, value, user_avatar } from "store/portal";
import trans from "helpers/_translation";
import { env } from "config";

export default defineComponent({
    name: "profile",
    props: {
        mode: {
            type: String,
            required: false,
            default: "dropdown"
        }
    },
    components: {
        Icon,
        Popup,
        WidgetField,
        Dropdown
    },
    setup() {

        const popupVisibility = reactive({
            add: false
        });

        const togglePopup = (trigger) => {
            popupVisibility[trigger] = !popupVisibility[trigger];
            popupVisibility[trigger] ? document.body.classList.add("VuePopupOpen") : document.body.classList.remove("VuePopupOpen");
        };

        return {
            env,
            value,
            user_avatar,
            contact,
            trans,
            togglePopup,
            popupVisibility
        };
    },
});
</script>